<template>
  <div class="has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>

    <div class="main-container">
      <div class="sidebar-container">
        <h5 class="sidebar-header">Filter auswählen:</h5>

        <FilterCompaniesAndGroups
          class="filter-list"
          @filter-change="onFilterChange"
          :init-selected-filter="selectedFilter"
          :type="filterType"
          :key="filterType + '-filter-' + JSON.stringify(selectedFilter)"
          :display-promo-count="false"
        />
        <FilterCompaniesAndGroups
          v-if="filterType2"
          class="filter-list"
          @filter-change="onFilterChange"
          :init-selected-filter="selectedFilter"
          :type="filterType2"
          :key="filterType2 + '-filter-' + JSON.stringify(selectedFilter)"
          :display-promo-count="false"
        />
      </div>

      <div class="role-container">
        <div
          style="
            font-size: 32px;
            text-align: left;
            color: var(--mp);
            border-bottom: 1px solid #ccc;
            padding: 5px;
            font-weight: 400;
            margin-bottom: 25px;
          "
        >
          Benutzerrollen
        </div>

        <div v-if="loading">
          <i class="fas fa-circle-notch fa-spin"></i>
          Bitte warten
          <br />
          Die Benutzerrollen werden gerade geladen
          <br />
        </div>

        <h5 v-else-if="!this.selectedFilter">
          Wählen Sie eine CompanyGroup oder Company aus...
        </h5>

        <div v-else-if="!hasPermissionToManageRoles">
          Sie haben keine Berechtigung, die Rollen für {{ companyOrGroupName }}
          zu verwalten
          <br style="clear: both" />
        </div>

        <b-row v-else class="list-container">
          <!-- ROLE SECTION START -->
          <b-col md="auto" class="half-width">
            <!-- ROLE FILTER -->
            <div class="name-filter">
              <i class="fas fa-search"></i>
              <input
                class="filter-input"
                v-model="roleFilter"
                placeholder="Rollen filtern"
                v-on:input="roleFilter = SanitizeInput(roleFilter)"
              />
            </div>
            <!-- ROLE LIST -->
            <div class="list">
              <div class="button-bar">
                <div
                  class="button add fix-button-width create-role-button"
                  @click="openCreateRoleModal()"
                >
                  <div class="label">Neue Rolle anlegen</div>
                </div>
              </div>
              <div class="scroll-content">
                <div
                  class="list-entry"
                  :key="index"
                  v-for="(role, index) in rolesFilteredList"
                  v-on:click="toggleRole(role)"
                  v-bind:class="{
                    selected: selectedRole && selectedRole.id === role.id,
                  }"
                >
                  <div
                    class="picture"
                    v-bind:style="{ 'background-color': role.color }"
                  >
                    <strong>{{ role.letter }}</strong>
                  </div>
                  <div class="label">{{ role.name }}</div>

                  <div class="position-right">
                    <div
                      class="picture text-center cursor-not-allowed"
                      v-if="role.immutable"
                    >
                      <i class="fas fa-lock fa-sm cursor-not-allowed"></i>
                    </div>
                    <div
                      class="picture text-center"
                      v-if="!role.immutable"
                      v-on:click="openDeleteRoleModal(role, $event)"
                    >
                      <i class="fas fa-trash fa-sm"></i>
                    </div>
                  </div>
                  <div class="position-right">
                    <div
                      class="picture text-center"
                      v-if="!role.immutable"
                      v-on:click="openEditRoleModal(role, $event)"
                    >
                      <i class="fas fa-edit fa-sm"></i>
                    </div>
                    <div
                      class="picture text-center"
                      v-else
                      v-on:click="openViewModal(role, $event)"
                    >
                      <i class="fas fa-eye fa-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- ROLE SECTION END -->

          <!-- USER SECTION START -->
          <b-col md="auto" class="half-width">
            <!-- USER FILTER -->
            <div class="name-filter">
              <i class="fas fa-search"></i>
              <input
                class="filter-input"
                v-model="userFilter"
                placeholder="Benutzer filtern"
              />
              <!-- <div class="button add fix-button-width" @click="openAddUserWizard();">
                <div class="label">Neuen Benutzer anlegen</div>
              </div> -->
            </div>
            <!-- USER LIST -->
            <div class="list">
              <div class="scroll-content">
                <div
                  class="list-entry"
                  :key="index"
                  v-for="(user, index) in usersFilteredList"
                  v-on:click="toggleUser(user)"
                  v-bind:class="{ selected: user.highlighted }"
                >
                  <div
                    v-if="!isExternalUser(user)"
                    class="picture"
                    v-bind:style="{
                      background: getProfilePictureCSS(user),
                    }"
                  ></div>
                  <div
                    v-else
                    class="picture text-center"
                    style="background-color: #ccc"
                  >
                    <strong>E</strong>
                  </div>
                  <div class="label">
                    {{ user.name }} &nbsp;
                    <small class="label-small">{{ user.email }}</small>
                  </div>
                  <div class="position-right">
                    <div
                      class="picture text-center"
                      v-bind:style="{ 'background-color': user.role.color }"
                      :title="user.role.name"
                      v-if="user.role"
                    >
                      <strong>{{ user.role.letter }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- USER SECTION END -->
        </b-row>
      </div>
    </div>

    <b-modal
      id="create-role-modal"
      title="Neue Rolle erstellen"
      @ok="createRole($event)"
    >
      <template v-if="roleToCreate">
        <b-form-group label="Name der Rolle">
          <b-form-input
            v-model="roleToCreate.name"
            placeholder="Geben Sie einen Namen für die Rolle ein"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Welche Berechtigungen soll die neue Rolle enthalten?"
        >
          <b-form-checkbox
            v-for="[permission, name] of Object.entries(basicPermissions)"
            :key="permission"
            :checked="roleToCreate.permissions[permission]"
            @change="roleToCreate.permissions[permission] = $event"
          >
            {{ name }}
          </b-form-checkbox>
        </b-form-group>
      </template>
    </b-modal>

    <b-modal id="view-role-modal" title="Rollenübersicht" ok-only>
      <template v-if="roleToView">
        <b-form-group label="Name der Rolle">
          <b-form-input v-model="roleToView.name" disabled></b-form-input>
        </b-form-group>
        <b-form-group label="Berechtigungen">
          <b-form-checkbox
            v-for="[permission, name] of Object.entries(basicPermissions)"
            :key="permission"
            :checked="roleToView.permissions[permission]"
            disabled
          >
            {{ name }}
          </b-form-checkbox>
        </b-form-group>
      </template>
    </b-modal>

    <b-modal
      id="edit-role-modal"
      title="Rolle bearbeiten"
      @ok="editRole($event)"
    >
      <template v-if="roleToEdit">
        <b-form-group label="Name der Rolle">
          <b-form-input
            v-model="roleToEdit.name"
            placeholder="Geben Sie einen Namen für die Rolle ein"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Welche Berechtigungen soll die Rolle enthalten?">
          <b-form-checkbox
            v-for="[permission, name] of Object.entries(basicPermissions)"
            :key="permission"
            :checked="roleToEdit.permissions[permission]"
            @change="roleToEdit.permissions[permission] = $event"
          >
            {{ name }}
          </b-form-checkbox>
        </b-form-group>
      </template>
    </b-modal>

    <b-modal
      id="delete-role-modal"
      title="Rolle löschen"
      @ok="deleteRole($event)"
    >
      <template v-if="roleToDelete">
        <p>Möchten Sie die Rolle {{ roleToDelete.name }} wirklich löschen?</p>
        <p>Dadurch werden folgende User deren Rollen verlieren:</p>
        <!-- TODO: Display users that have the role and allow to change their roles -->

        <ul class="delete-modal-user-list">
          <li class="header-row">
            <div>Name</div>
            <div>Alte Rolle</div>
            <div>Neue Rolle</div>
          </li>
          <li
            v-for="user of this.getUsersWhereRole(this.roleToDelete.id)"
            :key="user.id"
          >
            <div>{{ user.name }}</div>
            <div>{{ user.role_data.name }}</div>
            <!-- TODO: Display dropdown to select new role -->
            <div>{{ roleMap[0].name }}</div>
          </li>
        </ul>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterCompaniesAndGroups from "../lists/FilterCompaniesAndGroups";

export default {
  name: "userroles",
  components: { FilterCompaniesAndGroups },
  data() {
    return {
      // FILTER VARIABLES
      roleFilter: "",
      userFilter: "",
      //LIST ARRAYS
      rolesList: [],
      usersList: [],

      rolesFilteredList: [],
      usersFilteredList: [],

      //MAPS FOR LINKING STUFF
      roleMap: {},
      userMap: {},
      userRoleMap: {},

      //HELPERS
      selectedRole: null,
      selectedFilter: null,
      roleToCreate: null,
      roleToView: null,
      roleToEdit: null,
      roleToDelete: null,

      loading: true,

      saves: false,

      basicPermissions: [],
    };
  },
  created: function () {
    if (this.$store.state.jwt) {
      this.refresh();
    }
  },
  mounted: function () {},
  computed: {
    ...mapGetters([
      "companies",
      "companyGroups",
      "isSuperUser",
      "externalServicesMap",
      "storeSettings",
      "employeeMap",
      "roles",
    ]),

    authHeader() {
      return { Authorization: "Bearer " + this.$store.state.jwt };
    },

    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format("YYYY-MM-DD");
    },
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
      state.buttons.push({
        type: "block",
        icon: "fa-refresh",
        click: () => {
          view.refresh();
        },
        tooltip: "Daten neu laden",
      });
      state.buttons.push({
        type: "block",
        icon: "fa-cloud-download-alt",
        click: () => view.loadExternalUsersFromKundencenter(),
        tooltip: "Externe Benutzer vom Kundencenter laden",
        disabled:
          !this.selectedFilter ||
          this.selectedFilter.type !== "company" ||
          !this.hasPermissionToManageRoles,
      });
      return state;
    },
    filterType() {
      return this.$store.state.isSuperUser
        ? "both"
        : this.companyGroups.length > 0
        ? "companyGroups"
        : "companies";
    },
    filterType2() {
      return !this.$store.state.isSuperUser &&
        this.companyGroups.length > 0 &&
        this.companies.length > 0
        ? "companies"
        : null;
    },

    hasPermissionToManageRoles() {
      if (!this.selectedFilter) return null;
      if (this.isSuperUser) return true;

      return !!this.roles.find((role) =>
        (this.selectedFilter.type === "company" &&
          role.companyId === this.selectedFilter.companyId) ||
        (this.selectedFilter.type === "companyGroup" &&
          role.companyGroupId === this.selectedFilter.companyGroupId)
          ? role.role_data.permissions.includes("manage_roles")
          : false
      );
    },
    companyOrGroupName() {
      if (!this.selectedFilter) return null;
      const companyOrGroup =
        this.selectedFilter.type === "company"
          ? this.companies.find(
              (company) => company.id === this.selectedFilter.companyId
            )
          : this.companyGroups.find(
              (group) => group.id === this.selectedFilter.companyGroupId
            );
      return companyOrGroup?.name;
    },
  },
  watch: {
    roleFilter: function (val, oldVal) {
      this.filterRoles();
    },
    userFilter: function (val, oldVal) {
      this.filterUsers();
    },
    newRolename: function (val, oldVal) {
      this.checkRoleExisting();
    },
    companyId: function (val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: async function (force = false) {
      this.loading = true;
      this.roleFilter = "";
      this.userFilter = "";
      this.rolesList = [];
      this.usersList = [];
      this.rolesFilteredList = [];
      this.usersFilteredList = [];
      this.roleMap = {};
      this.userMap = {};
      this.userRoleMap = {};
      this.selectedRole = null;
      this.roleToEdit = null;
      this.roleToDelete = null;
      // this.selectedFilter = null;
      await this.loadCompanyGroups();
      await this.loadCompanies();
      await window.menubar.loadRoles();
      await this.loadRoles();
      this.loadBasicPermissions().catch(console.error);
    },

    loadCompanies: async function () {
      try {
        const response = await this.axios.get("/api/sec/list/companies", {
          headers: this.authHeader,
        });
        const companies = response.data.sort((compA, compB) => {
          const nameA = compA.name.toUpperCase();
          const nameB = compB.name.toUpperCase();
          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
        });
        this.$store.commit("setCompanies", companies);
      } catch (e) {
        this.showErrorToast(e);
      }
    },

    loadCompanyGroups: async function () {
      try {
        const response = await this.axios.get("/api/sec/list/companyGroups", {
          headers: this.authHeader,
        });
        this.$store.commit("setCompanyGroups", response.data);
      } catch (e) {
        this.showErrorToast(e);
      }
    },

    loadRoles: async function () {
      if (!this.selectedFilter || !this.hasPermissionToManageRoles) {
        this.loading = false;
        return;
      }

      const {
        companyGroupId,
        companyId,
        type: filterType,
      } = this.selectedFilter;

      const params =
        filterType === "company"
          ? { companyIds: [companyId] }
          : { companyGroupIds: [companyGroupId] };

      try {
        const response = await this.axios.get("/api/sec/roles", {
          params,
          headers: this.authHeader,
        });
        const data = response.data;

        this.rolesList = [...data];
        this.roleMap = {};

        const overviewA = [];
        for (let i = 0; i < data.length; i++) {
          const roleItem = {
            id: data[i].id,
            name: data[i].name,
            immutable: data[i].id < 1000,
            //active: data[i].active,
            //type: data[i].type,
            letter: data[i].name.charAt(0).toUpperCase(),
            color: this.toColor(data[i].name),
            // color: "var(--contrast-1)",
            permissions: data[i].permissions,
          };
          this.roleMap[data[i].id] = roleItem;
          overviewA.push(roleItem);
        }
        this.rolesList = overviewA;

        this.rolesList.sort(this.sortByName);
        this.rolesFilteredList = [...this.rolesList];

        await this.loadModelHasRole();
      } catch (e) {
        this.loading = false;
        this.showErrorToast(e);
      }
    },

    async loadBasicPermissions() {
      try {
        const response = await this.axios.get("/api/sec/basic-permissions", {
          headers: this.authHeader,
        });
        this.basicPermissions = response.data;
      } catch (e) {
        this.showErrorToast(e);
      }
    },

    loadModelHasRole: async function () {
      if (!this.selectedFilter) return;

      const {
        companyGroupId,
        companyId,
        type: filterType,
      } = this.selectedFilter;

      const paramsMap = {
        company: () => ({ companyId }),
        companyGroup: () => ({ companyGroupId }),
      };

      try {
        const response = await this.axios({
          method: "GET",
          headers: this.authHeader,
          url: "/api/sec/roles/getUserRoles",
          params: paramsMap[filterType](),
        });

        const data = response.data.map((mhr) => ({
          ...mhr,
          ...mhr.user,
          role: {
            color: this.toColor(mhr.role_data.name),
            letter: mhr.role_data.name.charAt(0).toUpperCase(),
            name: mhr.role_data.name,
          },
        }));
        this.usersList = [...data];
        this.orderUsersBySelectedRole(0);

        /*let overviewA = [];
        for (let i = 0; i < data.length; i++) {
          if (
            this.userMap[data[i].authuserId] !== undefined &&
            data[i].authuserId != null
          ) {
            let userRoleItem = {
              id: data[i].id,
              authuserId: data[i].authuserId,
              //immutable: data[i].immutable,
              role: this.roleMap[data[i].roleId],
            };
            this.userRoleMap[data[i].id] = userRoleItem;
            overviewA.push(userRoleItem);
          }
        }

        for (let i = 0; i < this.usersList.length; i++) {
          for (let j = 0; j < overviewA.length; j++) {
            if (overviewA[j].authuserId === this.usersList[i].authuserId) {
              this.usersList[i].userRoleID = overviewA[j].roleId;
              //this.usersList[i].immutable = overviewA[j].immutable;
              this.usersList[i].role = overviewA[j].role;
            }
          }
        }*/
        this.usersFilteredList = [...this.usersList];

        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    },

    loadExternalUsersFromKundencenter: async function () {
      this.loading = true;

      if (this.selectedFilter.type !== "company") return;

      try {
        const companyId = this.selectedFilter.companyId;
        const response = await this.axios.get("/api/sec/loadUsersFromKC", {
          params: { companyId },
          headers: this.authHeader,
        });

        // TODO: create 0 perm roles for loaded users
        this.createNoPermissionRoles(response.data, companyId);
      } catch (e) {
        this.showErrorToast(e);
      } finally {
        this.loading = false;
      }
    },

    createNoPermissionRoles: function (newUsers, companyId) {
      const newModelHasRoles = [];

      for (const [userId, userData] of Object.entries(newUsers)) {
        const userIndex = this.usersList.findIndex(
          (u) => userId === u.authuserId
        );

        if (userIndex === -1) {
          const newUser = {
            authuserId: userId,
            companyId,
            name: userData.firstname + " " + userData.lastname,
            firstName: userData.firstname,
            lastName: userData.lastname,
            roleId: 0,
            role_data: { name: "Keine Berechtigung", permissions: [] },
          };

          newModelHasRoles.push({ roleId: 0, userId });

          this.usersList = [...this.usersList, newUser];
          this.$set(this.userMap, userId, newUser);
        } else {
          const updatedUser = {
            ...this.usersList[userIndex],
            name: userData.firstname + " " + userData.lastname,
            firstName: userData.firstname,
            lastName: userData.lastname,
          };
          this.$set(this.usersList, userIndex, updatedUser);
          this.$set(this.userMap, userId, updatedUser);
        }
      }

      this.usersFilteredList = [...this.usersList];
      this.userFilter = "";

      for (const mhr of newModelHasRoles) {
        // TODO: update mhr
      }
    },

    async onFilterChange(newFilter) {
      if (
        newFilter.companyGroupId === -1 &&
        newFilter.type === "companyGroup"
      ) {
        this.selectedFilter = null;
        return;
      }
      this.selectedFilter = newFilter;
      await this.loadRoles();
      this.orderUsersBySelectedRole(0);
    },

    filterRoles() {
      let view = this;
      if (view.roleFilter === "") {
        view.rolesFilteredList = view.rolesList.slice();
        return;
      }
      view.rolesFilteredList = view.rolesList.filter(
        (e) =>
          e.name.toUpperCase().indexOf(view.roleFilter.toUpperCase()) > -1 ||
          (view.selectedRole != null && e.id === view.selectedRole.id)
      );
    },
    filterUsers() {
      if (this.userFilter === "") {
        this.usersFilteredList = [...this.usersList];
        return;
      }
      this.usersFilteredList = this.usersList.filter(
        (e) =>
          e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 ||
          e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1
      );
    },
    filterFilteredUsers() {
      if (this.userFilter === "") {
        this.usersFilteredList = this.usersFilteredList.slice();
        return;
      }
      this.usersFilteredList = this.usersFilteredList.filter(
        (e) =>
          e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 ||
          e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1
      );
    },

    toggleRole(role) {
      if (this.selectedRole === role) {
        this.selectedRole = null;
      } else {
        this.selectedRole = role;
      }

      for (let i = 0; i < this.usersList.length; i++) {
        if (
          this.selectedRole != null &&
          this.usersList[i].role &&
          this.usersList[i].role.id != null &&
          this.selectedRole.id === this.usersList[i].roleId
        ) {
          this.usersList[i].highlighted = true;
        } else {
          this.usersList[i].highlighted = false;
        }
      }
      this.orderUsersBySelectedRole(0);
    },

    toggleUser(user) {
      for (const u of this.usersList) {
        u.highlighted = u.authuserId === user.authuserId;
      }
      this.filterUsers();

      if (this.selectedRole == null) {
        this.$helpers.warning(
          "Eingabe fehlerhaft",
          "Bitte zuerst eine Benutzerrolle auswählen!"
        );
      } else if (user.authuserId === this.$store.getters.jwtId) {
        if (
          confirm(
            "Sind Sie sicher, dass Sie Ihre eigene Rolle verändern wollen?"
          )
        )
          this.updateUserRole(user.authuserId, this.selectedRole.id);
      } else if (user?.roleId === 4) {
        this.$helpers.warning(
          "Eingabe fehlerhaft",
          "Der Besitzer kann nicht verändert werden!"
        );
      } else if (user.role && user.immutable) {
        this.$helpers.warning(
          "Eingabe fehlerhaft",
          "Dieser Benutzer kann nicht verändert werden!"
        );
      } else if (
        (!user.role || this.selectedRole.id !== user.role.id) &&
        this.selectedRole.name.toLowerCase() !== "user"
      ) {
        this.updateUserRole(user.authuserId, this.selectedRole.id);
      } else if (this.selectedRole.id === user.role.id) {
        if (
          confirm(
            "Soll von diesem Benutzer wirklich die Benutzerrolle gelöscht werden? Dieser Benutzer hat anschließend keinen Zugriff mehr auf diesen Store."
          )
        ) {
          this.updateUserRole(user.authuserId, 0);
        }
      }
    },

    updateUserRole: function (authuserId, roleId) {
      let view = this;
      let url = "/api/sec/roles/setUserRole";
      let payload = {
        userId: authuserId,
        roleId,
      };
      if (this.selectedFilter.companyId) {
        payload = {
          ...payload,
          companyId: this.selectedFilter.companyId,
        };
      } else if (this.selectedFilter.companyGroupId) {
        payload = {
          ...payload,
          companyGroupId: this.selectedFilter.companyGroupId,
        };
      }

      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then(async (response) => {
          if (roleId === 0) {
            view.userRoleMap[authuserId] = null;

            for (let i = 0; i < view.usersList.length; i++) {
              if (authuserId === view.usersList[i].authuserId) {
                view.usersList[i].roleId = null;
                //view.usersList[i].immutable = data.immutable;
                view.usersList[i].role_data = {
                  name: "Keine Berechtigung",
                  permissions: 0,
                };
                view.usersList[i].highlighted = !view.usersList[i].highlighted;
              }
            }
            view.$helpers.success("Erfolg", "Benutzerrolle wurde gelöscht");
          } else {
            const data = response.data;

            view.userRoleMap[data.id] = {
              id: data.id,
              authuserId: data.authuserId,
              //immutable: data[i].immutable,
              role: view.roleMap[data.roleId],
            };

            for (let i = 0; i < view.usersList.length; i++) {
              if (data.authuserId === view.usersList[i].authuserId) {
                view.usersList[i].roleId = data.id;
                //view.usersList[i].immutable = data.immutable;
                view.usersList[i].role_data = view.roleMap[data.roleId];
                view.usersList[i].highlighted = !view.usersList[i].highlighted;
              }
            }
            view.$helpers.success("Erfolg", "Benutzerrolle wurde zugewiesen");
          }
          await view.loadRoles();
          if (authuserId === view.$store.getters.jwtId)
            await window.menubar.loadRoles();
          view.orderUsersBySelectedRole(1);
          this.$forceUpdate();
        })
        .catch((error) => {
          this.showErrorToast(error);
        });
    },

    orderUsersBySelectedRole(filtermethod) {
      this.usersList.sort(this.sortByName); // Maybe not needed, if it's already sorted
      let helperSelected = [];
      let helperNotSelected = [];
      let newArray = this.usersList.slice();
      let j = 0;
      let jj = 0;
      if (this.selectedRole !== null) {
        newArray = [];
        for (let i = 0; i < this.usersList.length; i++) {
          if (
            this.usersList[i].role &&
            this.usersList[i].roleId === this.selectedRole.id
          ) {
            helperSelected[j++] = this.usersList[i];
          } else {
            helperNotSelected[jj++] = this.usersList[i];
          }
        }
        newArray = helperSelected.concat(helperNotSelected);
        this.usersList = newArray.slice();
        this.usersFilteredList = newArray.slice();
      } else {
        this.usersList = this.usersList.sort(
          ({ roleId: a }, { roleId: b }) => b - a
        );
        this.usersFilteredList = [...this.usersList];
      }
      if (filtermethod === 0) this.filterUsers();
      else this.filterFilteredUsers();
      this.$forceUpdate();
    },

    sortByName: function (a, b) {
      if (!a?.name || !b?.name) return 0;

      if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
      if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
      return 0;
    },
    SanitizeInput(input) {
      input = input.replace(/[^A-Za-z0-9 -]/g, "");
      if (input.length > 32) {
        input = input.substring(0, 32);
      }
      return input;
    },

    isExternalUser(user) {
      return user.external;
    },
    getProfilePictureCSS(user) {
      if (!user.profileImage)
        return "var(--contrast-1) no-repeat center/cover  url(https://fileserver1.meindienstplan.de:8443/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S)";
      return (
        "var(--contrast-1) no-repeat center/cover  url(" +
        user.profileImage +
        ")"
      );
    },

    //
    // MODALS
    //

    openCreateRoleModal() {
      this.roleToCreate = {
        name: "",
        permissions: {},
      };
      this.$bvModal.show("create-role-modal");
    },
    async createRole(event) {
      try {
        let params = {};
        switch (this.selectedFilter?.type) {
          case "company":
            params = { companyId: this.selectedFilter.companyId };
            break;
          case "companyGroup":
            params = { companyGroupId: this.selectedFilter.companyGroupId };
            break;
        }
        const { name, permissions } = this.roleToCreate;
        const newPermissions = Object.entries(permissions)
          .filter(([, v]) => !!v)
          .map(([k]) => k);
        params = { ...params, name, permissions: newPermissions };
        const response = await this.axios.post("/api/sec/roles", params, {
          headers: this.authHeader,
        });
        if (response.status < 400) {
          this.$helpers.success("Erfolg", "Rolle wurde erstellt");
          await this.loadRoles();
        } else {
          this.showErrorToast({ message: "Fehler beim Erstellen der Rolle" });
          event?.preventDefault();
        }
      } catch (e) {
        this.showErrorToast(e);
        event?.preventDefault();
      }
    },

    openViewModal(role, event) {
      event.preventDefault();
      event.cancelBubble = true;
      const permissions = this.mapPermissionsToObject(role.permissions);
      this.roleToView = { ...role, permissions };
      this.$bvModal.show("view-role-modal");
    },

    openEditRoleModal(role, event) {
      event.preventDefault();
      event.cancelBubble = true;
      const permissions = this.mapPermissionsToObject(role.permissions);
      this.roleToEdit = { ...role, permissions };
      this.selectedRole = role;
      this.$bvModal.show("edit-role-modal");
    },
    async editRole(event) {
      try {
        const { name, permissions, id } = this.roleToEdit;
        const newPermissions = Object.entries(permissions)
          .filter(([, v]) => !!v)
          .map(([k]) => k);
        const params = { name, permissions: newPermissions };
        const response = await this.axios.put(`/api/sec/roles/${id}`, params, {
          headers: this.authHeader,
        });
        if (response.status < 400) {
          this.$helpers.success("Erfolg", "Rolle wurde aktualisiert");
          await this.loadRoles();
        } else {
          this.showErrorToast({ message: "Fehler beim Erstellen der Rolle" });
          event?.preventDefault();
        }
      } catch (e) {
        this.showErrorToast(e);
        event?.preventDefault();
      }
    },

    openDeleteRoleModal(role, event) {
      event.preventDefault();
      event.cancelBubble = true;
      this.roleToDelete = { ...role };
      this.selectedRole = role;
      this.$bvModal.show("delete-role-modal");
    },
    async deleteRole(event) {
      try {
        const promises = [];

        let companyOrGroupParams = {};
        switch (this.selectedFilter?.type) {
          case "company":
            companyOrGroupParams = { companyId: this.selectedFilter.companyId };
            break;
          case "companyGroup":
            companyOrGroupParams = {
              companyGroupId: this.selectedFilter.companyGroupId,
            };
            break;
        }

        for (const user of this.getUsersWhereRole(this.roleToDelete.id)) {
          promises.push(
            this.axios.put(
              "/api/sec/roles/setUserRole",
              {
                ...companyOrGroupParams,
                roleId: 0, // TODO: Get new role for user
                userId: user.authuserId,
              },
              {
                headers: this.authHeader,
              }
            )
          );
        }

        await Promise.all(promises); // Wait until all user roles are updated

        const response = await this.axios.delete(
          `/api/sec/roles/${this.roleToDelete.id}`,
          {
            headers: this.authHeader,
          }
        );
        if (response.status < 400) {
          this.$helpers.success("Erfolg", "Rolle wurde gelöscht");
          await this.loadRoles();
        } else {
          this.showErrorToast({ message: "Fehler beim Löschen der Rolle" });
          event?.preventDefault();
        }
      } catch (e) {
        this.showErrorToast(e);
        event?.preventDefault();
      }
    },

    //
    // HELPER FUNCTIONS
    //

    hashCode(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
      }
      return hash;
    },

    toColor(num) {
      if (typeof num === "string") num = this.hashCode(num);
      num *= 6;
      num >>>= 0;
      const b = num & 0xff,
        g = (num & 0xff00) >>> 8,
        r = (num & 0xff0000) >>> 16;
      return "rgba(" + [r, g, b, 0.5].join(",") + ")";
    },

    showErrorToast(error) {
      window.app.popupmessages.push({
        timer: 3000,
        type: "error",
        header: "Fehler",
        description: error.message,
      });
    },

    mapPermissionsToObject: (permissions) =>
      permissions.reduce((obj, perm) => ({ ...obj, [perm]: true }), {}),

    getUsersWhereRole(roleId) {
      return this.usersList.filter((u) => u.roleId === roleId);
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.main-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: stretch;
  height: 100%;
  color: var(--contrast-4);
}

.sidebar-container {
  flex: 2;
  max-width: 20rem;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-header {
  font-weight: bold;
  font-size: 1.25rem;
  padding: 0.5rem;
  text-align: left;
  background-color: var(--contrast-1);
  margin: 0;
}

.filter-list {
  flex: 100% 1 1;
  margin-bottom: 0;
}

.role-container {
  flex: 6;
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.list-container {
  max-width: 1300px;
  max-height: calc(100% - var(--header-height) - 2rem);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}

.half-width {
  flex: 50% 1 1;
  justify-self: stretch;
  align-self: stretch;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.name-filter {
  position: static;
  margin: 0 0 0.5rem;
}

.name-filter .fa-search {
  color: var(--contrast-4);
  top: 0.4rem;
  left: 1.75rem;
}

.fix-button-width {
  width: 150px;
}

.filter-input {
  padding-left: 40px;
  width: 100%;
  margin-left: 0;
}

.list {
  width: 100%;
  margin: auto;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  overflow: hidden;
  border-radius: 5px;
  flex: 100% 1 1;
  display: flex;
  flex-direction: column;
}

.list .scroll-content {
  padding: 5px;
  overflow-y: auto;
  flex-basis: 100%;
  position: static;
}

.list-entry {
  height: 35px;
  margin-bottom: 2px;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.list-entry:hover {
  background: var(--sub-menu);
  cursor: pointer;
}

.list-entry.selected {
  background: var(--mp);
  cursor: pointer;
}

.list-entry.selected > .label,
.list-entry:hover > .label {
  color: var(--bg);
  cursor: pointer;
}

.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
  color: var(--bg) !important;
  cursor: pointer;
}

.list-entry > .label {
  font-size: 1rem;
  font-family: DistrictProBook, sans-serif;
  color: var(--contrast-4);
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.list-entry > .label > .label-small {
  cursor: pointer;
  color: var(--contrast-5);
}

.picture {
  border-radius: 100px;
  background: var(--contrast-1);
  margin-left: 5px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
  flex: 25px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pictureImg {
  border-radius: 100px;
  height: 25px;
  width: 25px;
}

/* width */
.role-container::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.role-container::-webkit-scrollbar-track {
  background: var(--contrast-1);
}

/* Handle */
.role-container::-webkit-scrollbar-thumb {
  background: var(--contrast-3);
}

/* Handle on hover */
.role-container::-webkit-scrollbar-thumb:hover {
  background: #aaaaaa;
}

.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  overflow-x: hidden;
  top: var(--header-height);
  padding: 0 14px;
}

.button-bar {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: row;
  width: 100%;
  background-color: var(--contrast-1);
}

.create-role-button {
  position: relative;
  bottom: 0;
}

.delete-modal-user-list {
  list-style: none;
  background-color: var(--contrast-1);
  color: var(--contrast-4);
}

.delete-modal-user-list > .header-row {
  border-bottom: 1px solid var(--contrast-8);
}

.delete-modal-user-list > li {
  list-style: none;
  display: flex;
  flex-direction: row;
  padding: 0.25rem 0.5rem;
}

.delete-modal-user-list > li > div {
  flex: 1 1;
  text-align: center;
}
</style>
